import Api from '../api';

export const getCurriculum = async () => {
  const response = await Api.get(`/conteudo_exclusivo/get_curriculum`);
  return response;
};

export const getClipping = async () => {
  const response = await Api.get(`/conteudo_exclusivo/clipping_policia_federal`);
  return response;
};

export const ShowClipping = async (file: string) => {
  const response = await Api.post(`/conteudo_exclusivo/clipping_policia_federal/${file}`);
  return response;
};
